import { useLang } from "../lib/i18n";
import { PageHeader } from "../components/common";
import { AssistantChat } from "../components/ai/AssistantChat";

export default function Assistant() {
  const { t } = useLang();
  const examples = [
    t("Show my appointments tomorrow", "Muestra mis citas de mañana"),
    t("Which projects need attention?", "¿Qué proyectos requieren atención?"),
    t("Show customers who haven't responded in 30 days", "Muestra clientes que no han respondido en 30 días"),
    t("Create an estimate for John for stucco repair for $2,500 with a 50% deposit and one-year warranty", "Crea un presupuesto para John de reparación de estuco por $2,500 con 50% de depósito y un año de garantía"),
    t("Give me the PDF of my latest estimate", "Dame el PDF de mi último presupuesto"),
    t("Create a receipt for the last $400 payment and show the $800 project is paid in full", "Crea un recibo del último pago de $400 y muestra que el proyecto de $800 quedó pagado completamente"),
    t("Translate this message into professional English: ", "Traduce este mensaje a inglés profesional: "),
  ];
  return (
    <div>
      <PageHeader title={t("AI Assistant", "Asistente IA")} subtitle={t("Uses your customers, estimates, appointments and projects. Attach files, photos or dictate.", "Usa sus clientes, presupuestos, citas y proyectos. Adjunte archivos, fotos o dicte.")} />
      <AssistantChat examples={examples} />
    </div>
  );
}
